// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3B5Gw","header":"Messages_header__3C4gn"};